/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DirectionsService } from '../../models/directions-service';
import { JsonRouteResponse } from '../../models/json-route-response';

export interface GetDefaultUsingPost1$Any$Params {

/**
 * Specifies the route profile.
 */
  profile: 'driving-car' | 'driving-hgv' | 'cycling-regular' | 'cycling-road' | 'cycling-mountain' | 'cycling-electric' | 'foot-walking' | 'foot-hiking' | 'wheelchair';
  
    /**
     * The request payload
     */
    body: DirectionsService
}

export function getDefaultUsingPost1$Any(http: HttpClient, rootUrl: string, params: GetDefaultUsingPost1$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<JsonRouteResponse>> {
  const rb = new RequestBuilder(rootUrl, getDefaultUsingPost1$Any.PATH, 'post');
  if (params) {
    rb.path('profile', params.profile, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JsonRouteResponse>;
    })
  );
}

getDefaultUsingPost1$Any.PATH = '/v2/directions/{profile}';
